// activeOptions, debounce, setTabindex and addEventListeners are defined
// inline in the head (snippets/global-helpers.liquid), so they exist even
// when this file fails to load.

function getStyleProperty(element, property) {
  return window.getComputedStyle(element).getPropertyValue(property);
}

/*
 * Shopify Common JS
 *
 */

if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || "post";
  const params = options.parameters || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions(selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class QuantityCounter extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
    // Bound once: connectedCallback runs again whenever the counter is moved
    // (the cart drawer re-render can move a row), and re-adding the same
    // function is a no-op where a fresh bind would make a click count twice.
    this.onIncrease = this.onIncrease.bind(this);
    this.onDecrease = this.onDecrease.bind(this);
  }

  connectedCallback() {
    this.counterEl = this.querySelector(".js-counter-quantity");
    this.increaseBtn = this.querySelector(".js-counter-increase");
    this.decreaseBtn = this.querySelector(".js-counter-decrease");

    this.min = parseInt(this.counterEl.min) || 1;
    this.max = parseInt(this.counterEl.max) || 999;

    this.increaseBtn.addEventListener("click", this.onIncrease);
    this.decreaseBtn.addEventListener("click", this.onDecrease);
  }

  onIncrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (currentValue < this.max) {
      this.updateValue(currentValue + 1);
    }
  }

  onDecrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (this.dataset.cart) this.min = 0;
    if (currentValue > this.min) {
      this.updateValue(currentValue - 1);
    }
  }

  updateValue(value) {
    this.counterEl.value = value;

    this.counterEl.dispatchEvent(this.changeEvent);
  }
}

// Define the custom element
window.customElements.define("quantity-counter", QuantityCounter);

/**
 * While a cart line is being changed, the stepper belongs to the customer, not
 * to the server.
 *
 * Every cart update re-renders the row from Liquid, which throws away the
 * quantity input and builds a new one holding the cart's value. That value is a
 * round trip behind what has just been clicked, so the number visibly drops back
 * and then corrects itself. Three different places trigger such a re-render
 * (cart.js, cart-drawer.js and cart-free-gifts.js), so the guard lives here
 * rather than in any one of them.
 *
 * `restore()` must be called in the same task as the markup swap: no paint
 * happens in between, so the customer never sees the intermediate value.
 *
 * Everything is keyed by the line's `data-line-id` (snippets/cart-items-list.liquid),
 * not its line number: the free-gifts engine adds and removes lines at the top
 * of the cart, which shifts every line number below them while a change is
 * still queued, and a number-keyed intent would then land on the neighbouring
 * line. Nor by `item.key`, which changes whenever the line's discounts do.
 *
 * A line with an outstanding intent carries `wt-cart__item--updating` from the
 * click until the cart has caught up, so its prices can show they are about to
 * change (assets/custom-cart-drawer.css).
 */
window.cartQuantityIntent = {
  values: new Map(),
  // Queue state lives here rather than on a CartItems element, so the drawer
  // and the cart page share one queue and only one change is in flight at once.
  pending: new Map(),
  inFlight: new Set(),
  lastApplied: new Map(),
  // Set when a drawer redraw from elsewhere was held back (see renderContents
  // in assets/cart-drawer.js); the queue redraws once it has drained.
  refreshDrawerWhenIdle: false,

  /** A quantity change is queued or in flight. */
  isBusy() {
    return this.inFlight.size > 0 || this.pending.size > 0;
  },

  set(lineId, quantity) {
    if (lineId == null) return;
    this.values.set(String(lineId), String(quantity));
    this.markUpdating(lineId, true);
  },

  get(lineId) {
    return this.values.get(String(lineId));
  },

  has(lineId) {
    return this.values.has(String(lineId));
  },

  clear(lineId) {
    this.values.delete(String(lineId));
    this.markUpdating(lineId, false);
  },

  /** The line's quantity inputs: the drawer and the cart page can both hold one. */
  inputs(lineId) {
    return document.querySelectorAll(
      `.js-counter-quantity[data-line-id="${CSS.escape(String(lineId))}"]`,
    );
  },

  input(lineId) {
    return this.inputs(lineId)[0] || null;
  },

  markUpdating(lineId, updating) {
    this.inputs(lineId).forEach((input) => {
      input.closest(".wt-cart__item")?.classList.toggle("wt-cart__item--updating", updating);
    });
  },

  /** Re-apply every outstanding intent to the inputs currently in the DOM. */
  restore() {
    this.values.forEach((quantity, lineId) => {
      this.inputs(lineId).forEach((input) => {
        if (input.value !== quantity) input.value = quantity;
      });
      this.markUpdating(lineId, true);
    });
  },
};

// without under functions main-password doesn't work

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function toggleTabindex(elements) {
  elements.forEach((el) => {
    const tabindex = el.getAttribute("tabindex");
    el.setAttribute("tabindex", tabindex === "0" ? "-1" : "0");
  });
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// Safari detection
const detectSafari = () => {
  const ua = navigator.userAgent;

  const isSafari =
    ua.includes("Safari") &&
    !ua.includes("Chrome") &&
    !ua.includes("CriOS") &&
    !ua.includes("FxiOS") &&
    !ua.includes("Edg");

  const isMacOS = ua.includes("Macintosh");

  if (isSafari && isMacOS) {
    document.documentElement.classList.add("is-safari-macos");
  }
};

// Custom video controls
document.addEventListener("DOMContentLoaded", () => {
  detectSafari();

  const BUTTON_SELECTOR = ".wt-hero-video__sound-toggle";
  const BUTTON_TOGGLE_CLASS = "wt-hero-video__sound-toggle--unmuted";

  document.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
    button.addEventListener("click", () => {
      if (button.closest("video-controls")) return;
      const parent = button.parentElement;
      if (!parent) return;

      let video = null;

      video = Array.from(parent.children).find((el) => el.tagName === "VIDEO");

      if (!video) {
        const heroVideoContainer = Array.from(parent.children).find(
          (el) =>
            el.classList && el.classList.contains("hero--video-background"),
        );

        if (heroVideoContainer) {
          video = heroVideoContainer.querySelector("video");
        }
      }

      if (!video) {
        const grandparent = parent.closest("video-controls");
        video = Array.from(grandparent.children).find(
          (el) => el.tagName === "VIDEO",
        );
      }

      if (!video) return;

      video.muted = !video.muted;
      button.classList.toggle(BUTTON_TOGGLE_CLASS, !video.muted);
    });
  });
});

// Lazy autoplay for hosted videos.
// Liquid renders them with preload="none", no autoplay attribute and the class
// .wt-lazy-autoplay. A video starts fetching only when it enters the viewport,
// and is paused when it leaves. A copy hidden by a breakpoint class never
// intersects, so it is never downloaded; on resize or rotation the newly visible
// copy intersects and plays. Swiper's loop clones and section reloads in the
// editor are picked up by the MutationObserver.
(() => {
  if (!("IntersectionObserver" in window)) return;

  const SELECTOR = "video.wt-lazy-autoplay";
  const BLOCKED = "wt-lazy-autoplay--blocked";
  const visible = new Set();

  // iOS Low Power Mode (and any other autoplay block) rejects play() with
  // NotAllowedError. Only for the grid-view-drawer tiles: show a play glyph on
  // the wrapper (custom.css) and let the first tap start the video from a user
  // gesture. Everywhere else the poster simply stays. Skipped where the theme
  // has its own <video-controls> button, and inside links, where a tap navigates.
  const GLYPH_SCOPE = ".wt-grid-view-with-drawer";
  const wrapperOf = (video) => video.closest(".wt-video__movie") || video.parentElement;
  // The tap lands on the hero overlay that sits above the video, so listen on
  // the whole tile (.hero), not on the video wrapper.
  const tapTargetOf = (video) => video.closest(".hero") || wrapperOf(video);

  const markBlocked = (video) => {
    if (video.__lazyBlocked || !video.closest(GLYPH_SCOPE) || video.closest("video-controls, a")) return;
    const wrapper = wrapperOf(video);
    if (!wrapper) return;
    video.__lazyBlocked = true;
    wrapper.classList.add(BLOCKED);
    tapTargetOf(video).addEventListener(
      "click",
      (event) => {
        event.preventDefault();
        event.stopPropagation();
        tryPlay(video);
      },
      { once: true }
    );
  };

  const tryPlay = (video) =>
    video
      .play()
      .then(() => {
        if (video.__lazyBlocked) {
          video.__lazyBlocked = false;
          wrapperOf(video)?.classList.remove(BLOCKED);
        }
      })
      .catch((error) => {
        if (error?.name === "NotAllowedError") markBlocked(video);
      });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ target: video, isIntersecting }) => {
        if (isIntersecting) {
          visible.add(video);
          tryPlay(video);
        } else {
          visible.delete(video);
          if (!video.paused) video.pause();
        }
      });
    },
    // 200px above and below the viewport: a video starts before it scrolls
    // into view and is paused only once it is fully out of view, so the
    // play/pause switch (which rebuilds the video layer on iOS and made
    // overlaid buttons flicker) never happens on screen.
    { rootMargin: "200px 0px 200px 0px" }
  );

  // Chrome pauses muted video in a background tab; resume what is in view.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      visible.forEach((video) => tryPlay(video));
    }
  });

  const observe = (root) => {
    if (root.matches?.(SELECTOR)) observer.observe(root);
    root.querySelectorAll?.(SELECTOR).forEach((video) => observer.observe(video));
  };

  const start = () => {
    observe(document.body);
    new MutationObserver((mutations) => {
      mutations.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && observe(n)));
    }).observe(document.body, { childList: true, subtree: true });
  };

  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", start) : start();
})();
